"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var defaultFormat = function defaultFormat(value) {
  return value.toString();
};

var List = function List(_ref) {
  var values = _ref.values,
      _ref$ordered = _ref.ordered,
      ordered = _ref$ordered === void 0 ? false : _ref$ordered,
      _ref$customFormat = _ref.customFormat,
      customFormat = _ref$customFormat === void 0 ? defaultFormat : _ref$customFormat;
  if (!values) return null;
  return /*#__PURE__*/_react["default"].createElement(ordered ? 'ol' : 'ul', undefined, values.map(function (value, index) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: index
    }, customFormat(value));
  }));
};

var _default = List;
exports["default"] = _default;